import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'

export const floating = css`
  position: sticky;
  transition: filter 0.2s ease-in-out;
  will-change: filter;
`

export const top = css`
  top: 0;
  filter: drop-shadow(${cssTheme.shadows.bottomNormal});
`

export const bottom = css`
  bottom: 0;
  filter: drop-shadow(${cssTheme.shadows.topNormal});
`
